import conversationTypes from './conversations.types';

export const addConversationStart = conversationData => ({
	type: conversationTypes.ADD_NEW_CONVERSATION_START,
	payload: conversationData
});
  
export const fetchConversationsStart = (filters={}) => ({
	type: conversationTypes.FETCH_CONVERSATIONS_START,
	payload: filters
});
  
// export const fetchVendorsStart = productName => ({
// 	type: conversationTypes.FETCH_VENDORS_START,
// 	payload: productName
// });
  
export const setConversations = conversations => ({
	type: conversationTypes.SET_CONVERSATIONS,
	payload: conversations
});
  
export const deleteConversationStart = conversationID => ({
	type: conversationTypes.DELETE_CONVERSATION_START,
	payload: conversationID
});
  
export const fetchConversationStart = conversationID => ({
	type: conversationTypes.FETCH_CONVERSATION_START,
	payload: conversationID
});
  
export const setConversation = conversation => ({
	type: conversationTypes.SET_CONVERSATION,
	payload: conversation
});

export const fetchConversationsByServiceStart = productName => ({
	type: conversationTypes.FETCH_CONVERSATION_SERVICE_START,
	payload: productName
});

export const fetchCustomerConversationsStart = (filters={}) => ({
	type: conversationTypes.FETCH_CUSTOMER_CONVERSATION_START,
	payload: filters
});

  